import { APP_ROUTES } from './constant';

// Profile browsing has a durable URL: refresh, history and section returns
// must not silently switch the reader back to the public feed.
export const opinionPath = (id, username) => username
  ? `${APP_ROUTES.USER}/${encodeURIComponent(username)}${APP_ROUTES.REACTION}/${id}`
  : `${APP_ROUTES.REACTION}/${id}`;
